import { render, staticRenderFns } from "./ManagedConfigurationTable.vue?vue&type=template&id=15fc9ca6&%23items=props&"
import script from "./ManagedConfigurationTable.vue?vue&type=script&lang=js&"
export * from "./ManagedConfigurationTable.vue?vue&type=script&lang=js&"
import style0 from "./ManagedConfigurationTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fc9ca6')) {
      api.createRecord('15fc9ca6', component.options)
    } else {
      api.reload('15fc9ca6', component.options)
    }
    module.hot.accept("./ManagedConfigurationTable.vue?vue&type=template&id=15fc9ca6&%23items=props&", function () {
      api.rerender('15fc9ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/ManagedConfigurationTable.vue"
export default component.exports